import { createSlice } from '@reduxjs/toolkit';
import { Actividades_Rubrica } from 'generated/graphql';

const initialState: Partial<Actividades_Rubrica> = {};

const currentActividadRubricaStateSlice = createSlice({
	name: 'currentActividadRubricaState',
	initialState,
	reducers: {
		setCurrentActividadRubricaState: (state, action) => {
			return action.payload;
		},
		resetCurrentActividadRubricaState: () => {
			return initialState;
		}
	}
});

export const { setCurrentActividadRubricaState, resetCurrentActividadRubricaState } =
	currentActividadRubricaStateSlice.actions;
export default currentActividadRubricaStateSlice.reducer;
